import parse from 'html-react-parser';

export default function displaySubmitError({
  type,
  err,
  showGenericError,
}: {
  type: string;
  err: any;
  showGenericError: (s: string | JSX.Element | JSX.Element[]) => void;
}) {
  let errMessage: string;

  if (err?.response?.data?.info) {
    const { info } = err.response.data;
    const words = info.restricted_words.join();
    const { text, action, action_title } = info.message;
    const rest = `<a href="${action}">${action_title}</a>`;
    const capitalizedType = info.restricted_type[0].toUpperCase() + info.restricted_type.slice(1);

    errMessage = `${text.replace('%a', rest)} ${capitalizedType} words: ${words}`;
  } else {
    errMessage = err?.response?.data?.message || err.message;
  }

  // Bugsnag.notify(`Error on form ${type}: ${errMessage}`);
  console.error('Error on form ${type}', err);
  showGenericError(parse(errMessage));
}
